import React, { useEffect, useState } from 'react'
import { capitalize } from '@/custom/common/components'
import { Bar } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const getColorByIndex = (index) => {
    const hue = ((index * 360) / 10) % 360
    return `hsl(${hue}, 70%, 70%)`
}

const Table = ({ pieDetails, type }) => {
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedItem, setSelectedItem] = useState(null)

    useEffect(() => {
        if (pieDetails && type) {
            let dataArray = []
            let rawData = []

            if (type === 'browser') {
                if (
                    pieDetails.userIpBrowser &&
                    Array.isArray(pieDetails.userIpBrowser)
                ) {
                    rawData = pieDetails.userIpBrowser
                }
            } else if (type === 'device') {
                if (
                    pieDetails.userIpDevice &&
                    Array.isArray(pieDetails.userIpDevice)
                ) {
                    rawData = pieDetails.userIpDevice
                }
            }

            dataArray = rawData.map((item, index) => ({
                name: capitalize(item.name),
                count: item.count,
                color: getColorByIndex(index),
            }))

            setData(dataArray)
            setFilteredData(dataArray)
            setLoading(false)
        } else {
            setData([])
            setFilteredData([])
            setLoading(true)
        }
    }, [pieDetails, type])

    const handleItemClick = (name) => {
        if (selectedItem === name) {
            setSelectedItem(null)
            setFilteredData(data) // Show all data if the same item is double-clicked
        } else {
            setSelectedItem(name)
            const newFilteredData = data.filter((item) => item.name === name)
            setFilteredData(newFilteredData)
        }
    }

    const handleDoubleClick = (name) => {
        if (selectedItem === name) {
            setSelectedItem(null)
            setFilteredData(data) // Show all data if the same item is double-clicked
        }
    }

    const chartData = {
        labels: filteredData.map((item) => item.name),
        datasets: [
            {
                label: type === 'browser' ? 'Browser Views' : 'Device Views',
                data: filteredData.map((item) => item.count),
                backgroundColor: filteredData.map((item) => item.color),
            },
        ],
    }

    const hasData = filteredData.length > 0

    return (
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <h2>
                {type === 'browser'
                    ? 'Browser Information'
                    : 'Device Information'}
            </h2>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    marginBottom: '20px',
                }}
            >
                {data.map(({ name, color }) => (
                    <button
                        key={name}
                        onClick={() => handleItemClick(name)}
                        onDoubleClick={() => handleDoubleClick(name)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            margin: '5px',
                            padding: '5px',
                            fontSize: '16px',
                            color: selectedItem === name ? color : '#000',
                            fontWeight:
                                selectedItem === name ? 'bold' : 'normal',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: color,
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                marginRight: '10px',
                            }}
                        />
                        {name}
                    </button>
                ))}
            </div>

            {loading ? (
                <p>No data available</p>
            ) : hasData ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '80%' }}>
                        <Bar
                            data={chartData}
                            options={{
                                responsive: true,
                                plugins: {
                                    legend: {
                                        position: 'top',
                                    },
                                    tooltip: {
                                        callbacks: {
                                            label: (context) =>
                                                `${context.label}: ${context.raw}`,
                                        },
                                    },
                                },
                            }}
                        />
                    </div>
                </div>
            ) : (
                <p>No data available</p>
            )}
        </div>
    )
}

export default Table
